// [HIGHCHARTS-10-MIGRATION-TAG]: Find and delete/clean all places like this once the migration ends

import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import addSolidGauge from 'highcharts/modules/solid-gauge';
import addHeatmap from 'highcharts/modules/heatmap';
import addBoost from 'highcharts/modules/boost';
import addExporting from 'highcharts/modules/exporting';
import addXrange from 'highcharts/modules/xrange';
import addDumbbell from 'highcharts/modules/dumbbell';
import addPatternFill from 'highcharts/modules/pattern-fill';
import HighchartsMulticolorSeries from 'highcharts-multicolor-series';

export function getHighchartsV10() {
  return {
    Highcharts,
    highchartsMore,
    addSolidGauge,
    addHeatmap,
    addBoost,
    addExporting,
    addXrange,
    addDumbbell,
    addPatternFill,
    HighchartsMulticolorSeries,
  };
}
